<template>
  <v-card class="d-flex pa-2 flex-column" elevation="0">
      <TableView
          :headers="headers"
          :items="allData"
          :options.sync="options"
          :loading="loading"
          :totalData="totalData"
          :refresh-table="getData"
          :bodyFilter="true"
          :customTopActions="true"
          item-key="id"
          table-height="70vh"
        >           
        <template v-slot:top>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 32px;">
              <div>
                <p class="font-weight-black mb-1">History Upload MID</p>
              </div>

              <div style="display: flex; gap: 10px">
                <v-btn
                  icon
                  color="warning"
                  class="mb-2"
                  @click="getData"
                  :style="{ 'margin-right': '10px' }"
                  :loading="loading"
                  :disabled="loading"
                >
                  <v-icon>mdi-refresh</v-icon>
                  <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                </v-btn>
            
              </div>
            </div>
          </template>
           <template v-slot:body-prepend>
            <BodyFilterView
              :filters="filterData"
              :search.sync="search"
              :options.sync="options"
              @getDataParent="getData"
            />
          </template>
          <template v-slot:custom="{ item }">
            <StockMidBulkHistoryButton :item="item" />
          </template>
          <template v-slot:custom_status="{ item }">
        <v-chip
          class="status-chip"
          :color="item.status == 1 ? 'green' : 'red'"
          text-color="white"
        >
          {{ item.status == 1 ? 'Sukses' : 'Gagal' }}
        </v-chip> 
          </template>
      </TableView>
  </v-card>
</template>

<script>
import { date } from '../../../lib/helpers';
import { headersBulk, listStatus } from '../../mid/stock-mid/attributes';

export default {
  components: {
    StockMidBulkHistoryButton: () => import('./StockMidBulkHistoryButton.vue'),
    TableView: () => import("../../@drontVue/components/Table/TableView.vue"),
    BodyFilterView: () => import("../../@drontVue/components/BodyFilter"),
  },
  name: 'StockMidBulkHistory',
  data: () => ({
    isFirstLoad: false,
    options: {},
    view: false,
    dialog: false,
    headers: headersBulk,
    search: {
      fileName: '',
      userName: '',
      createdDate: [],
      status: '',
    },
    selectedRow: '',
    filterData: [
      { label: 'Nama File', field: 'fileName', type: 'text' },
      { label: '', field: 'empty_1', type: '' },
      { label: 'Uploaded By', field: 'userName', type: 'text'  },
      { label: 'Tanggal Pengajuan', field: 'createdDate', type: 'date-range' },
      { label: 'Status', field: 'status', type: 'select', items: listStatus },
    ],
  }),
  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('stockMid/bulk/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    updatedBulk() {
      this.getData();
    },
  },
  computed: {
    allData() {
      return this.$store.state.stockMid.bulk.allData;
    },
    totalData() {
      return this.$store.state.stockMid.bulk.totalData;
    },
    totalPage() {
      return this.$store.state.stockMid.bulk.totalPage;
    },
    loading() {
      return this.$store.state.stockMid.bulk.loading;
    },
    flashError: {
      get() {
        return this.$store.state.stockMid.bulk.flashError;
      },
      set() {
        this.$store.commit('stockMid/bulk/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.stockMid.bulk.flashErrorMessage;
    },
    updatedBulk() {
      return this.$store.state.stockMid.bulk.updatedBulk;
    },
  },
  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },
    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },
    getData() {
      this.$store.commit('stockMid/bulk/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('stockMid/bulk/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },
    clearSearch() {
      this.search.fileName = '';
      this.search.userName = '';
      this.search.createdDate = [];
      this.search.status = '';
      this.$nextTick(() => {
        this.$store.commit('stockMid/bulk/clearData');
        this.getData();
      });
    },
  },
};
</script>
<style scoped>
.status-chip {
  min-width: 80px;
  justify-content: center;
}
</style>